import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "./index.modules.css";
import React, { useEffect } from "react";
import styles from "./index.modules.json";
import SpmNodeNames from "../../spmd";
import { env, navigate } from "@alipay/rewards-common-tools/index";
import queryString from "query-string";
import { clickNode, expoComponent } from "../../utils/tracert";
function EntryPage(props) {
  var _window, _window$location;
  var iquicInfo = props.iquicInfo,
    _props$renderData = props.renderData,
    title = _props$renderData.title,
    img = _props$renderData.img,
    openBtnText = _props$renderData.openBtnText,
    downLoadBtnText = _props$renderData.downLoadBtnText,
    voucherInfo = props.voucherInfo,
    giftSourceInfo = props.giftSourceInfo;
  var _queryString$parse = queryString.parse((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search),
    giftVoucherParamHexString = _queryString$parse.giftVoucherParamHexString;
  useEffect(function () {
    // C位曝光
    expoComponent(iquicInfo, _objectSpread(_objectSpread({}, voucherInfo), giftSourceInfo));
  }, []);
  useEffect(function () {
    navigate.openApp({
      openType: "auto",
      giftVoucherParamHexString: giftVoucherParamHexString
    });
    clickNode(iquicInfo, SpmNodeNames.OpenBtn.key, false, _objectSpread(_objectSpread(_objectSpread({}, voucherInfo), giftSourceInfo), {}, {
      autoOpen: true
    }));
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.marmot-cloud.com/storage/iquic-mng/dev/common/png/8916aaa6-a8c0-4fcc-b688-0d6df69ea41f.png",
    alt: "",
    className: styles.logo
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement("img", {
    className: styles.img,
    src: img
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.openBtn,
    onClick: function onClick() {
      navigate.openApp({
        openType: "click",
        giftVoucherParamHexString: giftVoucherParamHexString
      });
      clickNode(iquicInfo, SpmNodeNames.OpenBtn.key, false, _objectSpread(_objectSpread(_objectSpread({}, voucherInfo), giftSourceInfo), {}, {
        autoOpen: false
      }));
    }
  }, openBtnText), /*#__PURE__*/React.createElement("div", {
    className: styles.downloadBtn,
    onClick: function onClick() {
      var url = env.getWalletDownLoadUrl();
      window.location = url;
      clickNode(iquicInfo, SpmNodeNames.DownLoadBtn.key, false, _objectSpread(_objectSpread({}, voucherInfo), giftSourceInfo));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, downLoadBtnText))));
}
export default EntryPage;
